export type BenchmarkState = 'below' | 'at' | 'above';

export const getBenchmarkState = (
  value: number,
  benchmark: number,
  operator: string
): BenchmarkState => {
  if (value === benchmark) return 'at';

  switch (operator) {
    case 'less_than':
    case 'less_than_or_equal':
      return value < benchmark ? 'below' : 'above';
    case 'greater_than':
    case 'greater_than_or_equal':
    default:
      return value > benchmark ? 'above' : 'below';
  }
};

export const HERO_COLOR: Record<BenchmarkState, string> = {
  below: 'text-red-600',
  at: 'text-sky-600',
  above: 'text-emerald-600',
};
